import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <section className="section-dark min-h-[70vh] flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <p className="font-display text-7xl font-black text-gold" data-testid="not-found-code">404</p>
        <h1 className="font-display text-2xl font-bold text-slate-100 mt-4">Page not found</h1>
        <p className="text-sm text-slate-400 mt-3">The page you are looking for does not exist, was moved, or the link is incorrect.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/" data-testid="not-found-home-btn" className="btn-gold !px-7 !py-3 text-sm"><Compass size={15} /> BACK TO HOME</Link>
          <Link to="/contact" data-testid="not-found-contact-btn" className="btn-outline !px-7 !py-3 text-sm">CONTACT US</Link>
        </div>
      </div>
    </section>
  );
}
